<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}

.history {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182EB;
  line-height: 20px;
  height: 25px;
  margin-top: 40px;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.defualt_text {
  // display: inline;
  color: #f56c6c;
  font-size: 12px;
  position: absolute;
  top: 2px;
  right: 120px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid transparent;
}

.status-visible {
  background: #f0f9eb;
  color: #67c23a;
  border-color: #e1f3d8;
}

.status-deleted {
  background: #fef0f0;
  color: #f56c6c;
  border-color: #fde2e2;
}

.status-set-default {
  background: #f5f7fa;
  color: #909399;
  border-color: #e4e7ed;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">车俩信息</div>
    <el-table class="el-table" :data="detailForm.vehicleList" border max-height="200px"
      style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column label="车型">
        <template slot-scope="scope">
          <div>{{ scope.row.vehicleBrand }} {{ scope.row.vehicleModel }}</div>
          <div class="defualt_text" v-if="scope.row.isDef == 'Y'">默认</div>
        </template>
      </el-table-column>
      <el-table-column prop="vehicleYearVersion" label="车辆年限（版本号）">
      </el-table-column>
      <el-table-column label="充电口位置">
        <template slot-scope="scope">
          <span v-if="scope.row.chargeConnectorPosition === 'LEFT_BACKEND'">左后</span>
          <span v-else-if="scope.row.chargeConnectorPosition === 'RIGHT_BACKEND'">右后</span>
          <span v-else-if="scope.row.chargeConnectorPosition === 'LEFT_FRONT'">左前</span>
          <span v-else-if="scope.row.chargeConnectorPosition === 'RIGHT_FRONT'">右前</span>
          <span v-else-if="scope.row.chargeConnectorPosition === 'FRONT'">正前方</span>
          <span v-else>{{ scope.row.chargeConnectorPosition }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdWhen" label="添加日期">
      </el-table-column>
      <!-- <el-table-column
              prop="vehicleNumber"
              label="车牌号">
          </el-table-column> -->
      <el-table-column label="是否默认车辆">
        <template slot-scope="scope">
          <span :class="scope.row.isDef === 'Y' ? 'status-tag status-visible' : 'status-tag status-set-default'">
            {{ scope.row.isDef === 'Y' ? '默认车辆' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="小程序状态">
        <template slot-scope="scope">
          <span :class="scope.row.isDel === 'N' ? 'status-tag status-visible' : 'status-tag status-deleted'">
            {{ scope.row.isDel === 'N' ? '可见' : '已删除' }}
          </span>
        </template>
      </el-table-column>

    </el-table>
    <div class="text-right margin-t-20">
      <button class="common-empty-button" @click="back()">返 回</button>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      chargeData: [],
      selections: [], // 表格选项
      pagination: pageConfig.detailPagination,
      editFlag: false,
      pageTitle: '客户详情',
      // 默认值设置
      detailForm: {
        vehicleList: [
          {
            vehicleNo: '111121342423423'
          },
          {
            vehicleNo: '1111111'
          },
          {
            vehicleNo: '1111111'
          },
        ],
      },
      custInfo: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: '',
        chargeValue: '',
      },
      activeName: 'first', //默认激活状态
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          {
            id: 'remark',
            label: '备注',
            type: 'primary',
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRemark(row)
            },
          },
        ],
      }, // 列操作按钮

      caroperates: {
        width: 220,
        fixed: 'right',
        list: []
      },
      historyDialogVisible: false, //未使用(已删除功能)
      thirdDialogFormVisible: false, //度电设置弹窗
      dialogTitle: '', //未使用(已删除功能)
      dialogLabel: '', //未使用(已删除功能)
      actInExpAmount: '', //未使用(已删除功能)
      recentInTime: '暂无充值记录', //未使用(已删除功能)
      totalChargeValue: '', //累计度电
      chargeBalanceValue: '', //剩余度电
      tipFlag: false, //度电设置弹窗错误提示语
      btnUse: false, //判断是否可以点击确定按钮
      remarkShow: true, //客户备注内容是否显示
      inputShow: false, //备注内容输入框
      btnShow: true, //备注内容编辑按钮
      editShow: false, //备注内容保存按钮
      remarkDialogFormVisible: false, //备注信息弹窗
      dialogRemarkForm: {
        //备注信息表单内容
        remark: '',
      },
      mobileLength: '', //手机号码位数

      // 车辆信息数据
      carInfoTable: [],
      carPagination: pageConfig.carPagination
    }
  },
  methods: {
    init() {
      if (this.$store.state.custObj) {
        this.custInfo = this.$store.state.custObj;
        this.getFormInfo()
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$H.post(_, _.$A.cust.getVehcileInfo, { custPhone: _.custInfo.mobile }).then((res) => {
        _.detailForm.vehicleList = res.data.data
        // _.$store.commit("setCurPhone", _.detailForm.mobile);
      })
    },
    back() {
      this.$router.push({
        name: "custList"
      })
    }
  },
  mounted() {
    this.init()
  },
}
</script>
